import React, { useEffect} from "react";
import {
  Button,
  Table,
  Space,
  Popconfirm,
  Modal
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, FileSearchOutlined} from "@ant-design/icons";


//mobx
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { toJS, runInAction, set } from "mobx";
//mobx'

import RoleInput from './RoleInput'

//配置权限
import Configuration from './Configuration'

const Role = () => {
  //mobx
  const { RoleStore } = useStore();

  //获得table数据
  useEffect(() => {
    RoleStore.getDataList();
    // eslint-disable-next-line
  }, []);

  //分页控制
  const onPageChange = (page, pageSize) => {
    runInAction(() => {
      set(RoleStore, { page: page, pagesize: pageSize })
    })
    RoleStore.getDataList()
  }
  //分页控制

  //关闭X按钮
  const handleRevise = () => {
    runInAction(() => {
      set(RoleStore, { isActive: false });
    });
  };

  //单个删除按钮
  const deleteConfirm = async (item) => {
    let id = toJS(item).id;
    toJS(RoleStore.dataList).filter((item) => item.id !== id);
    await RoleStore.getDeleteButtom(id);
  };

  //新增账户
  const getAddButton = (addTitle,data) => {
    if(addTitle==='编辑'){
      runInAction(() => {
        set(RoleStore, { valueData:toJS(data) });
      })
    }
    runInAction(() => {
      set(RoleStore, { title: addTitle,isActive: true });
    });
  };

   //配置按钮
   const collocation = async (item) => {
    console.log('111')
    let id = toJS(item).id
    // await RoleStore.getReviseRole(id)
    await RoleStore.getConfigPermission(id)
    runInAction(() => {
      set(RoleStore, { isOpen: true })
    })
  }
   //弹出框关闭按钮
   const handleCancel = () => {
    runInAction(() => {
      set(RoleStore, { isOpen: false })
    })
  }
  //table 列表
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "名称",
      dataIndex: "name",
    },
    {
      title: "创建时间",
      dataIndex: "createtime",
    },
    {
      title: "操作",
      render: (item) => (
        item.id === 1 ? null:
        <Space size="middle">
          <Button
            type="primary"
            icon={<FileSearchOutlined />}
            style={{ background: '#40ad63' }}
            onClick={() => collocation(item)}
          >配置</Button>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => getAddButton("编辑",item)}
          >编辑</Button>
          <Popconfirm
            title="是否删除?"
            okText="确定"
            cancelText="取消"
            onConfirm={() => {
              deleteConfirm(item);
            }}
          >
            {<Button type="primary" icon={<DeleteOutlined />} danger>删除</Button>}
          </Popconfirm>

        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="TableInput">
        <div className="buttonBox">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="addTitle"
            onClick={() => getAddButton("添加",'')}
          >
            添加角色
          </Button>
        </div>
        <div className="total">共有数据:{RoleStore.total}条</div>
      </div>
      <div className="contextNr">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          dataSource={RoleStore.dataList}
          className="table-box"
          pagination={{
            position: ["bottomCenter"],
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ['10', '20', '30'],
            pageSize: RoleStore.pagesize,
            current: RoleStore.page,
            total: RoleStore.total,
            onChange: (page, pageSize) => onPageChange(page, pageSize),
          }}
        />
      </div>
      <Modal
        title={RoleStore.title}
        key={new Date()}
        width="600px"
        open={RoleStore.isActive}
        footer={null}
        onCancel={handleRevise}
      >
        <RoleInput title={RoleStore.title} />
      </Modal>
      <Modal
          title="配置权限"
          width="600px"
          open={RoleStore.isOpen}
          footer={null}
          onCancel={handleCancel}
        >
          <Configuration />
        </Modal>
    </>
  );
};

export default observer(Role);
